import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Box } from '@mui/material';

/**
 * Breadcrumb component. Pass an array of { label, path, state? }.
 * Last item can have path: null to render as current (non-link).
 */
const Breadcrumb = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        const isLink = item.path != null && !isLast;
        return (
          <React.Fragment key={i}>
            {i > 0 && <Box component="span" sx={{ mx: 0.5 }}> / </Box>}
            {isLink ? (
              <Link
                to={item.path}
                state={item.state}
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                {item.label}
              </Link>
            ) : (
              <Box component="span" sx={{ color: 'text.primary', fontWeight: 500 }}>
                {item.label}
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </Typography>
  );
};

export default Breadcrumb;
